import { Box, SxProps, Theme } from '@mui/material';
import React, { ReactNode } from 'react';

import { pxToRem } from 'components/theme/typography';

type Props = {
    sx?: SxProps<Theme>;
    children: ReactNode;
};

const FormContainer = ({ sx, children }: Props) => (
    <Box
        sx={{
            display: {
                xs: 'flex',
                lg: 'block',
            },
            flexDirection: 'column',
            justifyContent: 'space-between',
            maxWidth: {
                lg: pxToRem(500),
            },
            mx: {
                lg: 'auto',
            },
            mt: {
                lg: pxToRem(80),
            },
            height: {
                xs: 'calc(100% - env(safe-area-inset-top))',
                lg: 'auto',
            },
            bgcolor: {
                lg: 'common.white',
            },
            borderRadius: {
                lg: pxToRem(12),
            },
            p: {
                lg: pxToRem(32),
            },
            ...sx,
        }}
    >
        {children}
    </Box>
);

export default FormContainer;
